import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { WhySplurge } from "@/components/landing/WhySplurge";
import { Features } from "@/components/landing/Features";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { About } from "@/components/landing/About";
import { BlogTeaser } from "@/components/landing/BlogTeaser";
import { Community } from "@/components/landing/Community";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { PressKit } from "@/components/landing/PressKit";
import { Footer } from "@/components/landing/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import { ScrollToTop } from "@/components/ScrollToTop";
import { Blog } from "@/pages/Blog";
import { BlogPost } from "@/pages/BlogPost";

const Home = () => (
  <main id="main">
    <Hero />
    <WhySplurge />
    <Features />
    <HowItWorks />
    <About />
    <BlogTeaser />
    <Community />
    <FinalCTA />
    <PressKit />
  </main>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen overflow-x-clip bg-splurge-bg font-sans text-splurge-ink">
        <a href="#main" className="skip-link" data-testid="skip-link">
          Skip to main content
        </a>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
        <Footer />
        <ChatWidget />
      </div>
    </BrowserRouter>
  );
}

export default App;
